import { SelectionBoxProps, SelectionBoxSize } from "../types";
import { VOTEBOX_WHITE } from "../voteboxTokens";
import CheckIcon from "../CheckIcon";
import { Box } from "./SelectionBox.styles";

const CHECK_SIZES: Record<SelectionBoxSize, number> = {
    large: 14,
    medium: 12,
    small: 12,
};
const CHECK_STROKE_WIDTHS: Record<SelectionBoxSize, number> = {
    large: 3.5,
    medium: 4,
    small: 4,
};

// Box drawn at the start of an option, checked when the option is selected: the selection
// is shown by a check mark, not only by the color (RGAA 3.1). Screen readers get aria-pressed.
const SelectionBox = ({
    color,
    isActive,
    isDisabled,
    size,
}: SelectionBoxProps) => {
    const checkMark = isActive ? (
        <CheckIcon
            color={color ?? VOTEBOX_WHITE}
            size={CHECK_SIZES[size]}
            strokeWidth={CHECK_STROKE_WIDTHS[size]}
        />
    ) : null;

    return (
        <Box
            aria-hidden="true"
            $color={color}
            $isActive={isActive}
            $isDisabled={isDisabled}
            $size={size}
        >
            {checkMark}
        </Box>
    );
};

export default SelectionBox;
